import React from 'react';
import { Button } from './ui/Button';
export function CommunitySection() {
  return <section className="relative py-24 md:py-32 flex items-center justify-center overflow-hidden" data-id="element-29">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-30">
        <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1600&h=600&fit=crop&q=80" alt="Спільнота людей" className="w-full h-full object-cover" data-id="element-31" />
        <div className="absolute inset-0 bg-[#0A5E5C]/90 mix-blend-multiply" data-id="element-32" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 text-center max-w-3xl" data-id="element-33">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-34">
          Поділіться своєю історією, надихніть інших
        </h2>

        <p className="text-lg text-white/90 mb-10 leading-relaxed" data-id="element-35">
          Кожна історія унікальна і важлива. Ваш досвід може допомогти іншим
          уникнути помилок або знайти вихід зі складної ситуації. Ми створюємо
          простір довіри, де ваш голос буде почутий.
        </p>

        <Button variant="outline" size="lg" className="border-[#D4A843] text-[#D4A843] hover:bg-[#D4A843] hover:text-white hover:border-[#D4A843]" data-id="element-36">
          Розповісти свою історію
        </Button>
      </div>
    </section>;
}